module.exports = __webpack_public_path__ + "media/src/assets/Images/Email-0d0c9e13e2abb3cdb1330f0957df7f13.svg";